// extracted by mini-css-extract-plugin
export default {"toggle":"_3Cwt8","tooltip":"_1RLIf","badge-icon":"_2xxid","badgeIcon":"_2xxid"};